var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('v-btn',_vm._b({attrs:{"disabled":_vm.evalDisabled,"title":_vm.evalTitle},on:{"click":_vm.handleClick}},'v-btn',_vm.$attrs,false),[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }